import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { useDevice } from '@bonnet/next/device';

import { useFeatures } from '@atc/features';

import {
    Button,
    SideBarToModal,
} from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { homeServicesConfig as homeServices } from 'reaxl-home-services';

import { inventoryWarrantyDetailClick } from '@/analytics/vdp/inventoryVehicleDetailsEvents';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

const fillDynamicValues = (content, replacements = {}) => Object.keys(replacements).reduce((string, key) => string.replace(`%${key}%`, replacements[key]), content);

function MoneyBackGuaranteeModal({
    buttonStyle = 'text-decorated',
}) {

    const {
        vdp_safeguard: [isSafeGuardEnabled],
    } = useFeatures([
        'vdp_safeguard',
    ]);

    const [showModal, setShowModal] = useState(false);
    const device = useDevice();
    const isXs = device?.is?.xs ?? false;

    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory) || {};
    const { returnPolicy = {} } = listing;

    const handleSeeDetailsClick = (event) => {
        sendClick(inventoryWarrantyDetailClick, event, { warrantyType: 'Peace of Mind', inventoryId: listing?.id });
    };

    const getMoneyBackGuaranteeDisclaimer = ({ days, miles, hasMoneyBackGuarantee, hasVehicleReturnPolicy }) => {
        if (hasMoneyBackGuarantee && hasVehicleReturnPolicy) return fillDynamicValues(homeServices.content.disclaimerMoneyBackAndExchange, { days, miles });
        if (hasMoneyBackGuarantee) return homeServices.content.disclaimerMoneyBack;
        if (hasVehicleReturnPolicy) return homeServices.content.disclaimerExchangePolicy;
        return homeServices.content.disclaimerMoneyBackDefault;
    };

    return (
        <>
            <Button
                bsStyle={buttonStyle}
                onClick={(event) => {
                    setShowModal(true);
                    handleSeeDetailsClick(event);
                }}
            >
                {isSafeGuardEnabled ? 'See ' : 'View '}
                Details
            </Button>

            <SideBarToModal
                collapsed={isXs}
                title="Peace of Mind Details"
                content={getMoneyBackGuaranteeDisclaimer(returnPolicy)}
                sideBarOptions={{
                    fullWidth: true,
                }}
                modalOptions={{
                    scrollPanel: false,
                    bsSize: 'small',
                }}
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    );

}

MoneyBackGuaranteeModal.propTypes = {
    buttonStyle: PropTypes.string,
};

export default MoneyBackGuaranteeModal;
